import { http } from "@/lib/api";

// Notificações push no navegador (Lote 34.2) — Web Push padrão (Service Worker + VAPID),
// sem depender de nenhuma API paga de terceiros. Este módulo só cuida da "encanamento"
// (permissão do navegador + registrar/cancelar a inscrição no backend); os toggles de
// antecedência ficam em Configurações (Settings.jsx).

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

// true = navegador suporta Push (Service Worker + PushManager + Notification API).
export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function getPushPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // "granted" | "denied" | "default"
}

// Inscreve este navegador/aparelho para receber push — pede permissão ao usuário (se
// ainda não decidida) e registra o endpoint no backend. Lança erro com mensagem em
// português pronta pra mostrar num toast.
export async function subscribeToPush() {
  if (!isPushSupported()) {
    throw new Error("Este navegador não tem suporte a notificações push.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permissão de notificações negada pelo navegador.");
  }
  const { data } = await http.get("/push/vapid-public-key");
  if (!data?.publicKey) {
    throw new Error("Notificações push ainda não configuradas neste servidor.");
  }
  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  const json = subscription.toJSON();
  await http.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return subscription;
}

// Cancela a inscrição deste navegador (tanto no navegador quanto no backend).
export async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  try {
    await http.post("/push/unsubscribe", { endpoint });
  } catch {
    /* best-effort — o navegador já cancelou de qualquer forma */
  }
}

// Checa se ESTE navegador já está inscrito (usado pra decidir o que mostrar em Configurações).
export async function isSubscribedToPush() {
  if (!isPushSupported()) return false;
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    return Boolean(subscription);
  } catch {
    return false;
  }
}
